// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Map.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import connect from 'share/enhancers/Izenda.Connect';
import MapStaticContentStore from 'logic/Izenda.MapStaticContentStore';
import AppGlobal from 'Izenda.AppGlobal';
import SimpleChart from './Izenda.SimpleChart';
import React, { Component } from 'react';
import mapActions from './Izenda.MapActions';
import { get, isEmpty, first, union, isObject, some } from 'lodash/fp';
import { ContainerName } from 'logic/data/Izenda.ReportPartMapConstants';

@connect(mapActions)
class Map extends Component {
  componentDidMount() {
    this.updateShownRecords(this.props);
  }

  componentWillReceiveProps(nextProps: Object) {
    if (this.props.seriesMap.shownRecords !== nextProps.seriesMap.shownRecords) {
      this.updateShownRecords(nextProps);
    }
  }

  updateShownRecords(props: Object) {
    const { seriesMap, chartOptions, updateShownRecords, filterRecordsByLatLon, filterValidRecords } = props;
    let shownRecords;
    const activePointOptionType = get('pointType', chartOptions.reportPartState.activePointOption);
    const activeSeries = chartOptions.reportPartState.activeSerie;

    const isMatchAnySeries = (series, activeSeriesName) =>
      isObject(series) && some(key => key === activeSeriesName, Object.keys(series));
    if (activePointOptionType === ContainerName.LATITUDE) {
      shownRecords = filterRecordsByLatLon(this.mapRef.chart, get('bubbleSeries', seriesMap));
    } else {
      let shownShadingRecords, shownBubbleRecords;
      if (isEmpty(activeSeries) || isMatchAnySeries(get('shadingSeries', seriesMap), activeSeries.name)) {
        shownShadingRecords = filterValidRecords(get('shadingSeries', seriesMap), 'shadingSeries');
      }
      if (isEmpty(activeSeries) || isMatchAnySeries(get('bubbleSeries', seriesMap), activeSeries.name)) {
        shownBubbleRecords = filterValidRecords(get('bubbleSeries', seriesMap), 'bubbleSeries');
      }
      shownRecords = union(shownShadingRecords, shownBubbleRecords);
    }

    updateShownRecords && updateShownRecords(shownRecords || []);
  }

  /**
   * Update map ref
   * @param {Object} com
   */
  mapRefFn = (com: any) => (this.mapRef = com);

  render() {
    const props = this.props;
    const { chartOptions, seriesMap } = props;
    const izendaOptions = get('commonOptions.izendaOptions', chartOptions);

    izendaOptions.backgroundMap = get('backgroundMap', props);
    izendaOptions.seriesMap = seriesMap;

    return (
      <section className='u_fullSize u-posRelative'>
        <SimpleChart {...props} chartOptions={chartOptions} ref={this.mapRefFn}>
          {props.children}
        </SimpleChart>
      </section>
    );
  }
}

export default class MapContainer extends Component {
  constructor() {
    super();

    this.state = {
      backgroundMap: null,
      mappingData: null,
      loadedCountryCodes: null
    };
  }

  componentDidMount() {
    this.isMountedComponent = true;
    // Get list country codes if didn't get before
    // Make sure we only get 1 times, it's a static array
    if (isEmpty(AppGlobal.countryCodes)) {
      MapStaticContentStore.getCountryCode().then(result => {
        AppGlobal.setCountryCodes(result);
        this.setState({ loadedCountryCodes: true });
      });
    } else {
      this.setState({ loadedCountryCodes: true });
    }
  }

  componentWillUnmount() {
    this.isMountedComponent = false;
  }

  setMapData = (key: string, value: any) => {
    const newData = {};
    newData[key] = value;
    this.isMountedComponent && this.state.loadedCountryCodes && this.setState(newData);
  };

  render() {
    const { props, state } = this;

    return (
      <Map
        {...props}
        backgroundMap={state.backgroundMap}
        mappingData={state.mappingData}
        setMapData={this.setMapData}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/charting/Izenda.Map.js